export default __webpack_public_path__ + "src/assets/bearishIndicator.c7ae509409bf42cf8f443111370be67a.svg";